// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderListCohortList_root__xu0aB"};